import React from "react";
import "./Layout.scss";

const Container = ({ children }) => {
  return <div className="container">{children}</div>;
};

export default Container;
